export default "__VITE_ASSET__KqiVSySi__"